import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Theme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";
import type { JSX } from "react";
import { ProgressWrapperBox } from "./stylesheet";

export interface ProgressRingProps {
    label: string;
    modal?: boolean;
    size?: "small" | "medium" | "large";
}

// Map string sizes to pixel values for CircularProgress
const sizeMap: Record<"small" | "medium" | "large", number> = {
    small: 24,
    medium: 30,
    large: 56,
};
// Map string sizes to pixel values for CircularProgress
const fontSizeMap: Record<"small" | "medium" | "large", number> = {
    small: 14,
    medium: 20,
    large: 30,
};

// Map string sizes to pixel values for CircularProgress
const gapSizeMap: Record<"small" | "medium" | "large", number> = {
    small: 2,
    medium: 2,
    large: 4,
};

export default function ProgressRing(props: ProgressRingProps): JSX.Element {
    const size = props.size ?? "small";

    const progressSize = sizeMap[size];
    const fontSize = fontSizeMap[size];
    const gapSize = gapSizeMap[size];

    function renderProgress(): JSX.Element {
        return (
            <Box
                sx={(theme: Theme) => ({
                    display: "flex",
                    alignItems: "center",
                    gap: gapSize,
                    color: theme.palette.text.primary,
                })}
            >
                <CircularProgress
                    variant="indeterminate"
                    size={progressSize}
                    sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                />
                <Typography sx={(theme: Theme) => ({ color: theme.palette.text.primary, fontSize: fontSize })}>
                    {props.label ?? "Loading..."}
                </Typography>
            </Box>
        );
    }

    return <ProgressWrapperBox data-testid="inline-progress">{renderProgress()}</ProgressWrapperBox>;
}
